import { lazy, Suspense, useState } from 'react';
import type { ShareWidgetProps } from './ShareWidgetDialog';

const ShareWidgetDialog = lazy(() =>
    import('./ShareWidgetDialog').then((module) => ({ default: module.ShareWidgetDialog }))
);

/**
 * The share dialog, fetched the first time it is opened: it brings the form inputs and three lookups, which only
 * the few who share widgets with the firm ever need on Home.
 */
export function ShareWidget(props: ShareWidgetProps) {
    const [wanted, setWanted] = useState(props.open);
    if (props.open && !wanted) {
        setWanted(true);
    }
    return wanted ? (
        <Suspense fallback={null}>
            <ShareWidgetDialog {...props} />
        </Suspense>
    ) : null;
}
